import PrescriptionFillUpsert from './prescription-fill-upsert-component';

export default PrescriptionFillUpsert;
